const getLocale = function () {
    return window.navigator.language.split('-')[0];
};

export const LocaleService = {
    getLocale,
};